import {Button, Typography, Box, Menu, MenuItem, useTheme} from "@mui/material";
import React, {useState} from "react";
import {useAuth} from "../../../AuthContext/authContext";
import {useNavigate} from "react-router-dom";
import DehazeIcon from '@mui/icons-material/Dehaze';
import useIsMobile from "../../../hooks/utilHooks/useIsMobile/useIsMobile";
import useIsTablet from "../../../hooks/utilHooks/useIsMobile/useIsTablet";

interface LoginComponentProps {
    setIsLoginDialogOpen: (isOpen: boolean) => void;
    setIsRegistrationDialogOpen: (isOpen: boolean) => void;
}

export const LoginComponent = (
    {
        setIsLoginDialogOpen,
        setIsRegistrationDialogOpen
    }: LoginComponentProps
) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const {logout, loginError, loggedInUserProfilePicture, loggedInUserEmail} = useAuth()
    const navigate = useNavigate()
    const isMobile = useIsMobile()
    const isTablet = useIsTablet()
    const theme = useTheme()

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);
    const isUserLoggedIn = loggedInUserEmail && !loginError

    if(isMobile || isTablet) {
        const menuOptions = isUserLoggedIn ? (
            <Box>
                <MenuItem
                    onClick={() => navigate(`/about`)}
                    sx={{
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                            cursor: 'pointer',
                        },
                    }}
                >
                    about
                </MenuItem>
                <MenuItem
                    sx={{
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                            cursor: 'pointer',
                        }
                    }}
                    onClick={() => navigate(`/my-trends`)}
                >
                    my trends
                </MenuItem>
                <MenuItem
                    sx={{
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                            cursor: 'pointer',
                        }
                    }}
                    onClick={() => navigate(`/tutorials`)}
                >
                    tutorials
                </MenuItem>
                <MenuItem
                    onClick={logout}

                >
                    log out
                </MenuItem>
            </Box>
        ) : (
            <Box>
                <MenuItem
                    onClick={() => navigate(`/about`)}
                    sx={{
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                            cursor: 'pointer',
                        },
                    }}
                >
                    about
                </MenuItem>
                <MenuItem
                    onClick={() => setIsRegistrationDialogOpen(true)}
                    sx={{
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                            cursor: 'pointer',
                        },
                    }}
                >
                    sign up
                </MenuItem>
                <MenuItem
                    onClick={() => setIsLoginDialogOpen(true)}
                    sx={{
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                            cursor: 'pointer',
                        },
                    }}
                >
                    log in
                </MenuItem>
            </Box>
        )
        const mobileLoginMenu = (
            <Menu
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={handleClose}
            >
                {menuOptions}
            </Menu>
        )

        return (
            <>
                {isUserLoggedIn && (
                    <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        sx={{flex: 1, maxHeight: '30px'}}
                    >
                        <Typography
                            variant="caption"
                            component="div"
                            align="center"
                            style={{fontSize: '14px'}}
                        >
                            Logged in as:
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{textAlign: 'center'}}
                            style={{fontSize: '10px'}}
                        >
                            {loggedInUserEmail}
                        </Typography>
                    </Box>
                )}
                <img
                    src={loggedInUserProfilePicture}
                    style={{
                        maxHeight: 35,
                        marginRight: '16px'
                    }}
                />
                <Button
                    onClick={handleClick}
                    variant="contained"
                    sx={{
                        boxShadow: 'none',
                        // minWidth: 0,
                        // padding: 0,
                        background: theme.palette.primary.dark,
                        // paddingRight: isMobile ? 2 : 0,
                        margin: 0,
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                            boxShadow: 'none',
                        },
                        '&:focus': {
                            outline: 'none',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DehazeIcon/>
                </Button>
                {mobileLoginMenu}
            </>

        )
    }
    if (isUserLoggedIn) return (
        <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
        >
            <Box
                display="flex"
                flexDirection="column"
                sx={{flex: 1, marginRight: '8px'}}
            >
                <Typography
                    variant="caption"
                    component="div"
                    align="center"
                >
                    Logged in as:
                </Typography>
                <Typography
                    variant="caption"
                    sx={{textAlign: 'center'}}
                >
                    {loggedInUserEmail}
                </Typography>
            </Box>
            <img
                src={loggedInUserProfilePicture}
                style={{
                    maxHeight: 35,
                    marginRight: '16px'
                }}
            />
            <Button
                color="inherit"
                variant="outlined"
                sx={{textTransform: 'none', cursor: 'pointer', minWidth: '90px', marginRight: '8px'}}
                onClick={() => navigate(`/about`)}
            >
                <Typography variant="caption">
                    about
                </Typography>
            </Button>
            <Button
                color="inherit"
                variant="outlined"
                sx={{textTransform: 'none', cursor: 'pointer', minWidth: '90px', marginRight: '8px'}}
                onClick={() => navigate(`/my-trends`)}
            >
                <Typography variant="caption">
                    my trends
                </Typography>
            </Button>
            <Button
                color="inherit"
                variant="outlined"
                sx={{textTransform: 'none', cursor: 'pointer', minWidth: '90px', marginRight: '8px'}}
                onClick={() => navigate(`/tutorials`)}
            >
                <Typography variant="caption">
                    tutorials
                </Typography>
            </Button>
            <Button
                color="inherit"
                variant="outlined"
                sx={{textTransform: 'none', cursor: 'pointer', minWidth: '90px'}}
                onClick={logout}
            >
                <Typography variant="caption">
                    log out
                </Typography>
            </Button>
        </Box>
    )

    return (
        <>
            <Button
                color="inherit"
                variant="outlined"
                sx={{textTransform: 'none', cursor: 'pointer', minWidth: '90px', marginRight: '8px',}}
                onClick={() => navigate(`/about`)}
            >
                <Typography variant="caption">
                    about
                </Typography>
            </Button>
            <Button
                color="inherit"
                variant="outlined"
                sx={{textTransform: 'none', minWidth: '80px', marginRight: '8px'}}
                onClick={() => setIsRegistrationDialogOpen(true)}
            >
                <Typography variant="caption">sign up</Typography>
            </Button>
            <Button
                color="inherit"
                variant="outlined"
                sx={{textTransform: 'none', cursor: 'pointer', minWidth: '90px', marginRight: '8px'}}
                onClick={() => navigate(`/tutorials`)}
            >
                <Typography variant="caption">
                    tutorials
                </Typography>
            </Button>
            <Button
                color="inherit"
                variant="outlined"
                sx={{textTransform: 'none', marginRight: '8px', size: 'small'}}
                onClick={() => setIsLoginDialogOpen(true)}
            >
                <Typography variant="caption">login</Typography>
            </Button>
        </>
    )
}